<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CN ParaOverride-1" id="_idParaDest-8"> </p>
<p class="PT"><a id="_idTextAnchor003"></a><a href="#/97808021888094#_idTextAnchor000">THE</a> BACK SEAT</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780802188809-7.vue?277cf144